import React from 'react';
import PropTypes from 'prop-types';
import AccountForm from 'Components/UI/Accounts/AccountForm/index';
import Typography from 'Components/UI/Typography';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

export const EXCLUDED_ACCOUNT_FIELDS = [
  'type',
  'institution',
  'note',
  'ownerClientId',
  'allocationType',
  'city',
  'state',
  'country',
  'phone',
  'abaRouting',
  'number',
  'monthlyAdditions',
  'maturityDate',
  'hasBeneficiary',
  'primaryBeneficiary',
  'contingentBeneficiary',
  'isDomestic',
  'dependentId',
  'annualAdditions',
  'otherType',
  'loanType',
  'interestRate',
  'principalInterestAmount',
  'insuranceAmount',
  'taxesAmount',
  'pmiAmount',
  'monthlyPayment',
  'description',
  'timeHorizon',
  'annuitants',
  'facetModel',
  'decedent',
  'dateOfDeath',
  'relationship',
  'balance',
  'name',
  'notes',
  'employeeAdditions',
  'employerAdditions',
  'currentEmployer',
  'active',
  'strikePrice',
  'expiration',
  'unvestedShares',
  'shares',
  'unvestedBalance',
  'currentYearContributions',
  'currentYearContributionsAsOf',
];

function AccountAccordionList({ accounts: accountsProp, onlyManaged, classes }) {
  const [selectedId, setSelectedId] = React.useState(null);
  const { logEvent } = useEventTrackingLogEvent();

  const handleSelect = (id) => {
    logEvent(
      '[Mission Control > Planner Data Tab]: Opened account form accordion',
    );
    setSelectedId(id === selectedId ? null : id);
  };

  const accounts = onlyManaged ? accountsProp.filter(acc => acc.attr('isManaged') === 'true') : accountsProp;

  return accounts.length ? accounts.map((acc) => {
    return (
      <AccountForm
        key={acc.id()}
        resource={acc}
        LayoutProps={{
          open: acc.id() === selectedId,
          toggleOpen: () => handleSelect(acc.id()),
          excludedFromRemainingFields: EXCLUDED_ACCOUNT_FIELDS,
        }}
      />
    );
  }) : (
    <div className={classes.noAssetsContainer}>
      <Paper className={classes.noAssets}>
        <Typography color="inherit">
          {onlyManaged ? 'This household has no Facet AUM' : 'This household has no accounts setup'}
        </Typography>
      </Paper>
    </div>
  );
}

AccountAccordionList.propTypes = {
  classes: PropTypes.object.isRequired,
  accounts: PropTypes.array.isRequired,
  onlyManaged: PropTypes.bool,
};

AccountAccordionList.defaultProps = {
  onlyManaged: false,
};

export default withStyles(theme => ({
  noAssets: {
    color: theme.palette.facet.primaryGray,
    backgroundColor: theme.palette.facet.lightGray,
    flexShrink: 1,
    padding: theme.spacing(1),
  },
  noAssetsContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
}))(AccountAccordionList);
